import React, { useState, useEffect, useRef } from 'react';
import './ThreeDCarousel.css';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

interface CarouselItem {
  id: number;
  image?: string;
  video?: string;
  title: string;
  type: 'image' | 'video';
}

const defaultItems: CarouselItem[] = [
  { id: 1, video: 'https://gqkdylnbgzxpbhdklgbx.supabase.co/storage/v1/object/sign/storage/enhance_1999788448196263938.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9iMjdjNTRhMy1kOWI2LTQ5ZWQtOGU2Mi05YmYwMWI4YTllNzQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJzdG9yYWdlL2VuaGFuY2VfMTk5OTc4ODQ0ODE5NjI2MzkzOC5tcDQiLCJpYXQiOjE3NjYxNzM3MTUsImV4cCI6NDkxOTc3MzcxNX0.7aVRhXHkIsDYJfVTvTPOjTxS4kCkU1-H2YfojK9KM94', title: 'Project Alpha', type: 'video' },
  { id: 2, video: 'https://gqkdylnbgzxpbhdklgbx.supabase.co/storage/v1/object/sign/storage/23c7516a-ee5c-4c24-9a64-aaeeb4f42bda.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9iMjdjNTRhMy1kOWI2LTQ5ZWQtOGU2Mi05YmYwMWI4YTllNzQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJzdG9yYWdlLzIzYzc1MTZhLWVlNWMtNGMyNC05YTY0LWFhZWViNGY0MmJkYS5tcDQiLCJpYXQiOjE3NjYxNzQ1MTAsImV4cCI6NDkxOTc3NDUxMH0.R-uKmLW8YIK45Z8W5DliFoCQaIDPPvPEnV3ehZH12Ws', title: 'Urban Life', type: 'video' },
  { id: 3, image: 'https://picsum.photos/id/239/600/800', title: 'Nature Story', type: 'image' },
  { id: 4, video: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/wrink.mp4', title: 'Tech Future', type: 'video' },
  // OSS: 这里使用“去掉签名参数”的稳定 URL；需要配合对象公共读 + Referer 白名单
  { id: 5, image: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimeng-2026-02-22-7170-%E5%86%99%E5%AE%9E%E6%BC%AB%E7%94%BB%E9%A3%8E%E6%A0%BC%EF%BC%8C%E6%B1%A4%E5%A7%86%E7%8C%AB%E5%92%8C%E6%9D%B0%E7%91%9E%E9%BC%A0%E4%BB%A5%E5%A4%B8%E5%BC%A0%E6%BB%91%E7%A8%BD%E3%80%81%E6%90%9E%E7%AC%91%E3%80%81%E6%80%AA%E8%AF%9E%E4%B8%8D%E7%BB%8F%E7%9A%84%E9%80%A0%E5%9E%8B%EF%BC%8C%E6%92%95%E5%BC%80%E6%8A%A5%E7%BA%B8%EF%BC%8C%E4%BB%8E%E8%A3%82%E7%BC%9D%E4%B8%AD....png', title: 'City Lights', type: 'image' },
  { id: 6, video: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimeng-2026-02-21-2495-%E9%A3%8E%E6%A0%BC%EF%BC%9A%20%E8%B6%85%E7%8E%B0%E5%AE%9E%E6%8F%92%E7%94%BB%E3%80%81%E5%86%B7%E8%89%B2%E8%B0%83%E3%80%81%E6%9E%81%E7%AE%80%E7%94%B5%E5%BD%B1%E8%B4%A8%E6%84%9F%20%20%E5%88%86%E9%95%9C%E8%AF%A6%E7%BB%86%E8%AE%BE%E8%AE%A1%EF%BC%9A%200-2%E7%A7%92%EF%BC%9A%E7%8B%82%E9%A3%8E%E8%B5%B7%E6%97%8B%20....mp4', title: 'Mountain High', type: 'video' },
  { id: 7, image: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimeng-2026-02-22-4795-%E5%9C%A8%E8%93%9D%E5%A4%A9%E7%99%BD%E4%BA%91%E7%9A%84%E5%9C%BA%E6%99%AF%E4%B8%AD%EF%BC%8C%E4%B8%80%E5%A4%B4%E9%A3%98%E9%80%B8%E7%9A%84%E9%95%BF%E5%8F%91%EF%BC%8C%E5%A4%B4%E6%88%B4%E6%A3%92%E7%90%83%E5%B8%BD%EF%BC%8C%E5%8D%8A%E9%81%AE%E7%9D%80%E9%82%A3%E5%BC%A0%E6%BC%82%E4%BA%AE%E7%9A%84%E8%84%B8%EF%BC%8C%E6%9C%89%E7%9D%80%E5%BE%AE%E9%86%BA%E7%9A%84%E6%A8%A1....png', title: 'Forest Whisper', type: 'image' },
  { id: 8, video: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/220.mp4', title: 'Ocean Blue', type: 'video' },
  { id: 9, image: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimeng-2026-02-22-8501-%E4%BB%A5%E5%85%85%E6%BB%A1%E6%B2%BB%E6%84%88%E6%84%9F%E7%9A%84%E5%AE%AB%E5%B4%8E%E9%AA%8F%E5%8A%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%E5%91%88%E7%8E%B0%EF%BC%8C%E5%B0%8F%E5%B1%8B%E5%9D%90%E8%90%BD%E5%9C%A8%E7%B9%81%E8%8A%B1%E4%B8%8E%E7%B2%89%E6%A8%B1%E7%B0%87%E6%8B%A5%E7%9A%84%E5%9C%B0%E6%96%B9%EF%BC%8C%E6%9E%84%E6%88%90%E4%BA%86%E6%A2%A6%E5%B9%BB%E8%88%AC%E7%9A%84....png', title: 'Desert Wind', type: 'image' },
  { id: 10, video: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimeng-2026-02-22-7434-Masterpiece%2C%20high%20quality%20anime%20style%2C%20g....mp4', title: 'River Flow', type: 'video' },
  { id: 11, image: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimeng-2026-02-22-7178-%E6%B0%B4%E5%BD%A9%E7%94%BB%EF%BC%8C%E6%9E%81%E7%B9%81%E4%B8%BB%E4%B9%89%EF%BC%8C%E6%9E%81%E8%87%B4%E8%A1%A8%E7%8E%B0%E5%8A%9B%EF%BC%8C%E7%8E%89%E6%A0%91%E4%B8%B4%E9%A3%8E%EF%BC%8C%E7%BB%86%E8%8A%82%E5%AE%8C%E7%BE%8E%EF%BC%8C%E5%A4%A7%E5%B8%88%E6%9D%B0%E4%BD%9C%E3%80%82%E4%B8%AD%E5%9B%BD%E5%B0%91%E5%B9%B4%EF%BC%8C%E7%94%B7%E6%80%A7%EF%BC%8C%E9%BB%91%E5%8F%91....png', title: 'Sky High', type: 'image' },
  { id: 12, video: 'https://vwin-ai.oss-cn-hongkong.aliyuncs.com/show/jimengtutu7.mp4', title: 'Night Dream', type: 'video' },
];

const ThreeDCarousel: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const cellCount = defaultItems.length;
  const [isPaused, setIsPaused] = useState(false);
  const sceneRef = useRef<HTMLDivElement>(null);

  // Configuration
  const cardWidth = 260; // Slightly smaller width to fit more cards
  const gap = 100; // Increased gap for more space between cards
  const effectiveWidth = cardWidth + gap;
  const radius = Math.round((effectiveWidth / 2) / Math.tan(Math.PI / cellCount));

  const rotateCarousel = () => {
    const angle = (360 / cellCount) * selectedIndex * -1;
    if (sceneRef.current) {
      sceneRef.current.style.transform = `translateZ(-${radius}px) rotateY(${angle}deg)`;
    }
  };

  useEffect(() => {
    rotateCarousel();
  }, [selectedIndex, radius, cellCount]);

  // Auto rotation
  useEffect(() => {
    if (isPaused) return;
    
    const interval = setInterval(() => {
      setSelectedIndex(prev => prev + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const handlePrev = () => {
    setSelectedIndex(prev => prev - 1);
  };

  const handleNext = () => {
    setSelectedIndex(prev => prev + 1);
  };

  // Normalize index for indicators (0 to cellCount-1)
  const normalizedIndex = ((selectedIndex % cellCount) + cellCount) % cellCount;

  return (
    <div 
      className="carousel-container" 
      style={{ marginBottom: '60px' }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="carousel-scene" ref={sceneRef}>
        {defaultItems.map((item, index) => {
          const angle = (360 / cellCount) * index;
          // Check if this card is the currently selected one (normalized)
          const isCurrent = index === normalizedIndex;

          const handleCardClick = () => {
            let diff = index - normalizedIndex;
            // Shortest path logic
            if (diff > cellCount / 2) diff -= cellCount;
            if (diff < -cellCount / 2) diff += cellCount;
            setSelectedIndex(prev => prev + diff);
          };

          return (
            <div
              key={item.id}
              className={`carousel-card ${isCurrent ? 'active' : ''}`}
              style={{
                transform: `rotateY(${angle}deg) translateZ(${radius}px)`,
                '--bg-img': item.type === 'video' ? 'none' : `url(${item.image})`
              } as React.CSSProperties}
              onClick={handleCardClick}
            >
              <div className="carousel-card-inner">
                {item.type === 'video' ? (
                  <video 
                    src={item.video} 
                    className="carousel-card-img" 
                    loop 
                    muted 
                    autoPlay
                    playsInline
                  />
                ) : (
                  <img src={item.image} alt={item.title} className="carousel-card-img" />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThreeDCarousel;
